const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const optionalNumber = value => value == null || (typeof value === 'number' && Number.isFinite(value));
const optionalText = value => value == null || typeof value === 'string';

// Validate transport shape only. Never add timing/position filters or reorder picks.
export const readNeverCandidates = (byBall, ball) => {
  const raw = record(byBall) ? byBall[ball] : undefined;
  if (!Array.isArray(raw)) return { candidates: [], unavailable: raw != null || (byBall != null && !record(byBall)) };
  const candidates = raw.filter(candidate => record(candidate)
    && Number.isInteger(candidate.predicted_number) && candidate.predicted_number >= 1 && candidate.predicted_number <= 50
    && Number.isInteger(candidate.diff) && Number.isInteger(candidate.last_value)
    && optionalNumber(candidate.current_gap) && optionalNumber(candidate.avg_bounce_back)
    && optionalNumber(candidate.overall_count) && optionalText(candidate.tier)
    && optionalText(candidate.current_month_name));
  return { candidates, unavailable: candidates.length !== raw.length };
};

export const neverMonthName = meta => typeof meta?.month_name === 'string' ? meta.month_name : 'the current month';
